<div class="range" [class.range--disabled]="disabled()">
  <div class="track">
    <div
      class="track__activo"
      [style.left.%]="desdePct()"
      [style.right.%]="100 - hastaPct()"
    ></div>
  </div>

  <input
    type="range"
    class="thumb"
    [min]="min()"
    [max]="max()"
    [step]="step()"
    [value]="desde()"
    [disabled]="disabled()"
    (input)="onDesde($event)"
    [attr.aria-label]="magnitud() + ' desde'"
  />
  <input
    type="range"
    class="thumb"
    [min]="min()"
    [max]="max()"
    [step]="step()"
    [value]="hasta()"
    [disabled]="disabled()"
    (input)="onHasta($event)"
    [attr.aria-label]="magnitud() + ' hasta'"
  />
</div>

@if (!disabled()) {
  <div class="valores">
    <span class="valor">{{ desdeLabel() }}</span>
    <span class="valores__sep">–</span>
    <span class="valor">{{ hastaLabel() }}</span>
  </div>
}
